<template>
  <div class="about-us" oncontextmenu="return false" onselectstart="return false">
    <!--顶部-->
    <header-nav :current="current"></header-nav>
    <div class="content" id="pdfDom">
      <div class="table" :class="{'pdfheight': isPrint}">
        <h1 class="title">
          <p>【汉语儿童理解与表达词汇测验】</p>
            <br/>
          <p>七岁以上超龄儿童个人报告</p>
        </h1>
        <div class="author">
          <p>
            <i>
              Receptive and Expressive Vocabulary Test （REVT）
            </i>
          </p>
          <p>黄瑞珍、简欣瑜、朱丽璇、卢璐编制</p>
        </div>

        <div class="head-title">
          <p class="main-title tx-l">基本资料</p>
          <p class="sn tx-l" style="color: #0c2047">个案编号：{{baseInfo.sn}}</p>
        </div>
        <table border="1" cellspacing="1" cellpadding="0">
          <tr>
            <th width="140px">姓名</th>
            <td>
              <div class="input">
                <span>{{baseInfo.name}}</span>
              </div>
            </td>
            <th width="140px">评估日期</th>
            <td>
              <div class="input">
                <span>{{baseInfo.exam_date}}</span>
              </div>
            </td>
          </tr>
          <tr>
            <th width="140px">性别</th>
            <td>
              <div class="input">
                <span>{{baseInfo.sex}}</span>
              </div>
            </td>
            <th width="140px">出生日期</th>
            <td>
              <div class="input">
                <span>{{baseInfo.birthday}}</span>
              </div>
            </td>
          </tr>
          <tr>
            <th width="140px">地区</th>
            <td>
              <div class="input">
                <span>{{baseInfo.province}}</span>
              </div>
            </td>
            <th width="140px">实足年龄</th>
            <td>
              <div class="input">
                <span>{{baseInfo.age}}</span>
              </div>
            </td>
          </tr>
          <tr>
            <th width="140px">就读学校</th>
            <td>
              <div class="input">
                <span>{{baseInfo.school}}</span>
              </div>
            </td>
            <th width="140px">施测人员</th>
            <td>
              <div class="input">
                <span>{{baseInfo.operator}}</span>
              </div>
            </td>
          </tr>
          <tr>
            <th width="140px">转介者</th>
            <td>
              <div class="input">
                <span>{{baseInfo.referral_user}}</span>
              </div>
            </td>
            <th width="140px">转介理由</th>
            <td>
              <div class="input">
                <span>{{baseInfo.referral_reason}}</span>
              </div>
            </td>
          </tr>
          <tr>
            <th width="140px">家中排行</th>
            <td>
              <div class="input">
                <span>{{baseInfo.rank}}</span>
              </div>
            </td>
            <th width="140px">家庭儿童人数</th>
            <td>
              <div class="input">
                <span>{{baseInfo.children_num}}</span>
              </div>
            </td>
          </tr>
          <tr>
            <th width="140px">障碍手册</th>
            <td>
              <div class="input">
                <span>{{baseInfo.obstacle_book}}</span>
              </div>
            </td>
            <th width="140px">障碍程度</th>
            <td>
              <div class="input">
                <span>{{baseInfo.obstacle_level}}</span>
              </div>
            </td>
          </tr>
          <tr>
            <th width="140px">障碍类型</th>
            <td>
              <div class="input">
                <span>{{baseInfo.obstacle_type}}</span>
              </div>
            </td>
            <th width="140px">主要照顾者</th>
            <td>
              <div class="input">
                <span>{{baseInfo.care_man}}</span>
              </div>
            </td>
          </tr>
          <tr>
            <th width="140px">双亲国籍</th>
            <td>
              <div class="input">
                <span>{{baseInfo.nationality}}</span>
              </div>
            </td>
            <th width="140px">家中语言</th>
            <td>
              <div class="input">
                <span>{{baseInfo.language}}</span>
              </div>
            </td>
          </tr>
          <tr>
            <th width="140px">施测地点</th>
            <td>
              <div class="input">
                <span>{{baseInfo.operator_area}}</span>
              </div>
            </td>
            <th width="140px"></th>
            <td>
              <div class="input">
                <span></span>
              </div>
            </td>
          </tr>
        </table>
        <p class="main-title tx-l">量表介绍</p>
        <div class="info-description">
          <p class="tips tx-idt2">
            《汉语儿童理解与表达词汇测验》（REVT）由黄瑞珍、简欣瑜、朱丽璇、卢璐参考国内外文献，从认知发展的角度探讨儿童词汇学习的特质与进程，同时参考汉语词汇特性编制本测验，并本着严谨的态度保证其验证结果的信效度。本测验分成理解与表达两个量表，以下又细分为四个分测验。测验目的是帮助使用者理解学龄前儿童的词汇发展，用来鉴定词汇发展迟缓儿童，以利于早期介入、早期疗育。
          </p>
          <p class="tips tx-idt2">
            理解量表：理解（receptive；简称R）是指对于言辞意义的了解或解码，代表听话者了解他人说话内容的能力。理解量表主要以施测者依据题本给予指示，请儿童依据题目要求进行词汇选择。量表内容依据3-7岁儿童认知发展细分为「命名」、「归类」、「定义」以及「推理」四个分测验。
          </p>
          <p class="tips tx-idt2">
            表达量表：表达（expressive；简称E）则是指使用言辞概念说出的过程或编码，表示个人产生有意义言语的能力。表达量表施测方式为施测者依据题目提问，儿童以口述的方式表达自己对词汇的概念。测验内容依据3-7岁儿童认知发展细分为「命名」、「归类」、「定义」以及「推理」四个分测验。
          </p>
        </div>
      </div>
      <br>
      <br>
      <!-- 分测验分数结果 -->
      <div class="table" :class="{'pdfheight': isPrint}">
        <p class="main-title tx-l">各年龄组题目答对率</p>
        <div class="charts" id="charts2" style="height: 550px"></div>
        <table border="1" style="width: auto !important;">
          <tr>
            <th class="score-td-title">
            </th>
            <th style="width: 190.2px !important;">三岁组</th>
            <th style="width: 188px !important;">四岁组</th>
            <th style="width: 189px !important;">五岁组</th>
            <th style="width: 188px!important;">六岁组</th>
          </tr>
          <template>
            <tr>
              <td class="score-td-title">
                答对率
              </td>
              <td class="score-td">{{ageEcharts[0]}}%</td>
              <td class="score-td">{{ageEcharts[1]}}%</td>
              <td class="score-td">{{ageEcharts[2]}}%</td>
              <td class="score-td">{{ageEcharts[3]}}%</td>
            </tr>
          </template>
        </table>
        <!-- 表格列出所有分数 -->
        <p class="main-title tx-l">分测验、量表答对率</p>
        <div class="charts" id="charts3" style="height: 550px"></div>
        <!-- 表格列出所有分数 -->
        <table border="1" style="width: auto !important;">
          <tr>
            <th class="score-td-title">
            </th>
            <th style="width: 146px !important;">命名</th>
            <th style="width: 144px !important;">归类</th>
            <th style="width: 144px !important;">定义</th>
            <th style="width: 144px !important;">推理</th>
            <th style="width: 144px !important;">全量表</th>
          </tr>
          <tr >
            <td class="score-td-title">理解量表</td>
            <td class="score-td" v-for="(score,index) in understand" :key="index">{{ score }}%</td>
          </tr>
          <tr >
            <td class="score-td-title">表达量表</td>
            <td class="score-td" v-for="(score,index) in express" :key="index">{{ score }}%</td>
          </tr>
        </table>
      </div>
      <div class="table" :class="{}">
        <p class="main-title tx-l">分数说明</p>
        <table border="1">
          <tr>
            <td style="width: 135px;">各年龄答对率</td>
            <td>借由各年龄组答对率了解儿童的语言能力落在哪一个年龄阶段，以及哪个年龄阶段的能力仍在发展当中。在某一年龄组中若答对率高于50％，代表儿童已发展到该年龄组的词汇能力。若答对率低于50％，代表该年龄组之词汇能力还在学习当中。</td>
          </tr>
          <tr>
            <td style="width: 135px;">分测验答对率</td>
            <td>本量表包含理解与表达两个量表，且理解与表达量表各自包含命名、归类、定义与推理四个分测验。因儿童的词汇能力伴随认知发展，会先发展出「命名」能力累积大量词汇，再发展出「归类」能力，并从对词汇简单的「定义」能力发展出以功能角度来定义词汇。再随着年龄的增长对相似词汇可以做进一步的区别，并推理两者的关系，而发展出「推理」能力。因此可以以分测验答对率来了解儿童的理解能力、表达能力发展的状况。若某一分测验答对率高于50％，代表儿童已具备该词汇发展能力。若答对率介于16％-50％，代表该能力还在发展中，若答对率低于16％以下，代表该能力尚未发展。</td>
          </tr>
          <tr>
            <td style="width: 135px;">量表答对率</td>
            <td>本量表包含理解量表与表达量表，代表儿童了解他人说话内容的能力（理解），及儿童产生有意义言语的能力（表达）。从两个量表的答对率可以了解幼儿的语言能力是理解的问题，还是表达的问题，以及两者之間发展的差异情形。</td>
          </tr>
        </table>
      </div>
      <div class="table" :class="{'pdfheight': isPrint}">
        <p class="main-title tx-l">个人分数说明、介入计划与建议</p>
      </div>
      <div class="table" :class="{'pdfheight': isPrint}">
        <p class="subheading">个人分数说明</p>
        <p style="padding-left: 30px;font-size: 18px;font-weight: bold;">各年龄组得分与答对率</p>
        <table border="0">
          <tr v-for="(content,index) in results" :key="index">
            <td>
              {{content}}
            </td>
          </tr>
        </table>
      </div>
      <div class="table" :class="{'pdfheight': isPrint}">
        <p class="subheading">介入计划与建议</p>
        <table border="1">
          <tr>
            <th></th>
            <th>建议</th>
          </tr>
          <tr>
            <td style="width: 75px;">命名</td>
            <td>
              命名为儿童最早发展的语言技巧之一，为基本的语意技巧，基于命名，其他语意技巧才得以建立。为增进儿童的词汇命名能力，建议增加儿童的生活经验，让儿童能在不同的生活环境当中接触到不同的词汇，包含不同种类的名词，例如人物(叔叔、阿姨、人物姓名等)、事物名(铅笔、背包、消防车等)、时间词(早上、下午等)、方位词(上、下、左、右等)、量词(个、杯、片等)、动词(拿、提、踏等)、形容词(美丽的、厚厚的等)、副词(刚刚、已经)…等。可借由游戏的方式让孩子学习各种不同的词汇，以引导的方式，例如词汇联想、语词接龙等游戏，帮助扩展儿童理解与表达的词汇量，组织词汇网络，增加词汇提取速度及搜寻能力。
            </td>
          </tr>
          <tr>
            <td style="width: 75px;">归类</td>
            <td>
              归类能力是发展逻辑思考发展的重要指针，为增进儿童的词汇归类能力，建议协助儿童将词汇经过整理而重新归类，例如使用相似的特征来形成归类(例如都是圆形的、都是长长的、都可以穿的)，或使用物品的真实类别来进行归类(例如水果、运动用品、餐具等)，引导儿童发展出上层词汇与下层词汇的分层概念，例如水果(上层词汇)有香蕉、苹果、菠萝、西瓜…等(下层词汇)。使儿童能根据物品不同的属性，找出共同点来归类，将词汇做有效率的储存，以帮助儿童有效的记忆及运用词汇。
            </td>
          </tr>
          <tr>
            <td style="width: 75px;">定义</td>
            <td>
              词汇定义能力对于能够清楚的、有效的沟通而言，是很重要的能力，为增进儿童的词汇定义能力，建议协助儿童理解词汇的完整概念，包括物品的功能、特征、材质，例如铅笔是用来写字的、长的细细长长的、用木头做成的。而抽象的词汇可使用同义词、解释或详述类别关系来增进儿童的词汇定义能力，例如「立刻」是什么意思?可以使用同义词「马上」、「即刻」来定义；「平安」则可以说是安全、没有危险等解释的方式来定义。
            </td>
          </tr>
          <tr>
            <td style="width: 75px;">推理</td>
            <td>
              词汇推理是比较两个词汇所表征的相同点与相异点，也是人类的一样基本能力。为增进儿童的词汇推理能力，建议引导儿童先比较两个词汇间的概念以及背景知识之关系，进而进行推理。例如相反关系的推理(大和小的关系就如同高和矮的关系)；特征属性的推理(香蕉和水果的关系就如同西兰花和蔬菜的关系)；部分与整体的推理(轮子和车子的关系就如同螺旋桨和直升机的关系)…等。练习时，可由具体的、视觉或感官上可观察到的词汇先进行训练，再进行抽象词汇的训练。
            </td>
          </tr>
        </table>
      </div>
      <div class="table" :class="{'pdfheight': isPrint}">
        <p class="main-title tx-l">施测者观察记录<span style="font-size: 12px !important;">（双击下方空白区域可编辑观察记录）</span></p>
        <table border="1">
          <tr>
            <td style="height: 250px;">
              <div v-if="!isEditing" @dblclick="startEdit" style="padding: 10px; min-height: 230px; white-space: pre-wrap;">{{ remark }}</div>
              <div v-else>
                <textarea v-model="editingRemark" style="width: 100%; height: 170px; padding: 10px; border: 1px solid #dcdfe6; border-radius: 3px; resize: vertical; font-size: 16px; font-family: inherit; box-sizing: border-box;"></textarea>
                <div style="text-align: right; padding: 8px 10px 0;">
                  <button type="button" @click="saveRemark" style="padding: 5px 18px; background: #0c2047; color: #fff; border: none; border-radius: 3px; cursor: pointer; font-size: 14px;">保存</button>
                  <button type="button" @click="cancelEdit" style="padding: 5px 18px; margin-left: 6px; background: #fff; color: #333; border: 1px solid #ccc; border-radius: 3px; cursor: pointer; font-size: 14px;">取消</button>
                </div>
              </div>
            </td>
          </tr>
        </table>
      </div>
      <div class="table">
        <p class="main-title tx-l">备注</p>
        <div style="padding: 10px 0 25px 28px;font-size: 22px;font-weight: bold;color: #333">如果您对本测验结果或解释有任何疑问，或是想进一步了解的地方，请与施测人员共同澄清讨论。</div>
      </div>
    </div>

    <button class="print" v-on:click="printPdf">打印</button>
    <button class="print" v-on:click="download">下载</button>
    <!--底部-->
    <footer-nav></footer-nav>
  </div>
</template>

<script>
import HeaderNav from "@/components/HeaderNav";
import FooterNav from "@/components/FooterNav";
import echarts from "echarts";
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'

export default {
  name: "aboutus",
  data() {
    return {
      current: "",
      baseInfo:{},
      isPrint: false,
      ageEcharts:{},
      understand:{},
      express:{},
      results:[],
      remark: '',
      editingRemark: '',
      isEditing: false
    };
  },
  components: {
    HeaderNav,
    FooterNav
  },
  methods: {
    getData() {
      let params = {
        exam_id: this.$route.query.eid
      };
      this.$post("report/getReport", params)
          .then(res => {
            if (res.code === 1) {
              this.baseInfo = res.data.base_info
              this.remark = res.data.remark || '';
              this.ageEcharts = res.data.age.echarts
              this.results = res.data.result
              this.understand = res.data.understand.echarts
              this.express = res.data.express.echarts
              this.$nextTick(() => {
                this.drawLine(this.ageEcharts); //页面上没有charts2元素，会报错
                this.drawLine2(res.data.understand.echarts,res.data.express.echarts);
                if (this.$route.query.print) {
                  setTimeout(async ()=>{
                    await this.download();
                  },1000)
                }
              });

            } else {
              this.$layer.msg(res.msg);
            }
          })
          .catch(response => {
            this.$layer.msg("网络异常，请稍后重试！");
          });
    },
    printPdf() {
      this.exportPDF()
      return false

      this.isPrint = true;
      setTimeout(() => {
        this.getPdf("七岁以上超龄儿童汉语婴幼儿沟通及语言筛查测验", () => {
          this.isPrint = false;
        });
      }, 1500)
    },
    async exportPDF() {
      const element = document.getElementById("pdfDom")
      const pdf = new jsPDF("p","mm","a4")
      const pageWidth = 210
      const pageHeight = 297
      let positionY = 10

      const elements = Array.from(element.children)
      function captureElement(index,name){
        if (index >= elements.length){
          pdf.save('七岁以上超龄儿童个人报告_'+name+'.pdf')
          return
        }
        const child = elements[index]
        html2canvas(child,{scale:2}).then((canvas)=>{
          const imgData = canvas.toDataURL("image/png");
          const imgWidth = pageWidth - 20
          const imgHeight = (canvas.height * imgWidth) / canvas.width
          if (positionY + imgHeight > pageHeight - 1){
            pdf.addPage()
            positionY = 1
          }
          pdf.addImage(imgData,'PNG',10,positionY,imgWidth,imgHeight)
          positionY += imgHeight + 1
          captureElement(index + 1,name)
        })
      }
      captureElement(0,this.baseInfo.name)
    },
    drawLine2(understand = [],express = []) {
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById("charts3"));
      // 绘制图表
      // 绘制图表
      let seriesLabel = {
        normal: {
          formatter:"{c}",
          show:true,
          fontSize:16,
          position:'top'
        }
      };
      myChart.setOption({
        title: {
          text: "",
          textAlign: "left",
          x: "center",
          y: "top"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          },
          formatter:function (params) {
            let str = '';
            str += '<div style="padding: 2px 6px">' + params[0].name + '<br>' + params[0].seriesName + ':' + params[0].data + '%'
            str += '<br>' + params[1].seriesName + ':' + params[1].data + '%' + '</div>'
            return str;
          },
        },
        legend: {
          x: "right",
          y: "top",
          textStyle: {
            fontSize: 18     // 修改字体大小（默认12px）
          },
        },
        grid: {
          left: "90px",
          right: "6%",
          bottom: "6%",
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: [
              "命名",
              "归类",
              "定义",
              "推理",
              "全量表"
            ],
            axisLabel: {
              fontSize:18
            }
          }
        ],
        yAxis: {
          name: "答对率%",
          nameTextStyle: {
            fontSize: 18,  // 设置字体大小（单位px）,
          },
          type: "value",
          min:0,
          max:100,
          interval:10,
          splitLine: {
            lineStyle: {
              color: '#000', // 默认刻度线（灰色虚线）
              width: 1,
              type: 'dashed'
            }
          },
          axisLabel: {
            fontSize:18,
            formatter: function (value) {
              if (value === 50) {
                return '{a|' + value + '}'; // 使用富文本标记
              }
              return value;
            },
            rich: {
              a: {
                fontWeight: 'bold',
                color: '#3c7088',
                fontSize: 18
              }
            }
          }
        },
        series: [
          {
            name:"理解量表",
            type: "bar",
            barWidth:'20%',
            label: seriesLabel,
            data: understand,
            markArea: {
              z: -1,
              silent: true,
              itemStyle: {
                color: 'transparent'
              },
              data: [
                // 第一个背景区间：0 到 60，颜色为浅红色
                [
                  {yAxis: 100,itemStyle: {color: 'rgba(49, 48, 255,0.7)'}},
                  {yAxis: 95}
                ],
                // 第二个背景区间：60 到 80，颜色为浅黄色
                [
                  {yAxis: 95,itemStyle: {color: 'rgba(156, 154, 255,0.7)'}},
                  {yAxis: 85}
                ],
                [
                  {yAxis: 85,itemStyle: {color: 'rgba(206, 207, 255,0.7)'}},
                  {yAxis: 70}
                ],
                [
                  {yAxis: 70,itemStyle: {color: 'rgba(255,255,255,0)'}},
                  {yAxis: 0}
                ]
              ]
            },
            markLine: {
              silent: true,
              symbol: 'none',
              lineStyle: {
                width: 2,
                type: 'solid'
              },
              data: [{ yAxis: 50 }],
              z: 0,  // 分割线层级调低（在柱状图下方）
              label: { show: false }
            },
            itemStyle:{
              color:'#5b9bd5'
            }
          },
          {
            name:"表达量表",
            type: "bar",
            barWidth:'20%',
            label: seriesLabel,
            data: express,
            itemStyle:{
              color:'#ed7d31'
            },
            markArea: {
              z: -1,
              silent: true,
              itemStyle: {
                color: 'transparent'
              },
              data: [
                // 第一个背景区间：0 到 60，颜色为浅红色
                [
                  {yAxis: 100,itemStyle: {color: 'rgba(49, 48, 255,0.8)'}},
                  {yAxis: 95}
                ],
                // 第二个背景区间：60 到 80，颜色为浅黄色
                [
                  {yAxis: 95,itemStyle: {color: 'rgba(156, 154, 255,0.8)'}},
                  {yAxis: 85}
                ],
                [
                  {yAxis: 85,itemStyle: {color: 'rgba(206, 207, 255,0.8)'}},
                  {yAxis: 70}
                ],
                [
                  {yAxis: 70,itemStyle: {color: 'rgba(255,255,255,0)'}},
                  {yAxis: 0}
                ]
              ]
            },
            markLine: {
              silent: true,
              symbol: 'none',
              lineStyle: {
                width: 2,
                type: 'solid',
                color: '#5b9bd5'
              },
              data: [{ yAxis: 50 }],
              z: 0,  // 分割线层级调低（在柱状图下方）
              label: { show: false }
            }
          }
        ]
      });
    },
    drawLine(data) {
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById("charts2"));
      // 绘制图表
      let seriesLabel = {
        normal: {
          show: true,
          color: "black",
          fontSize:18,
          position: "top" //在上方显示
        }
      };
      myChart.setOption({
        title: {
          textAlign: "left",
          x: "center",
          y: "top"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        grid: {
          left: "90px",
          right: "6%",
          bottom: "6%",
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: [
              "三岁组",
              "四岁组",
              "五岁组",
              "六岁组"
            ],
            axisLabel: {
              fontSize:18
            }
          }
        ],
        yAxis: {
          name: "答对率%",
          nameTextStyle: {
            fontSize: 18,  // 设置字体大小（单位px）,
          },
          type: "value",
          min:0,
          max:100,
          interval:10,
          splitLine: {
            lineStyle: {
              color: '#000', // 默认刻度线（灰色虚线）
              width: 1,
              type: 'dashed'
            }
          },
          axisLabel: {
            fontSize:18,
            formatter: function (value) {
              if (value === 50) {
                return '{a|' + value + '}'; // 使用富文本标记
              }
              return value;
            },
            rich: {
              a: {
                fontWeight: 'bold',
                color: '#3c7088',
                fontSize: 18
              }
            }
          }
        },
        series: [
          {
            type: "bar",
            barWidth:'30%',
            label: seriesLabel,
            data: data,
            itemStyle: {
              // 设置渐变色
              color:'#5b9bd5'
            },
            markArea: {
              z: -1,
              silent: true,
              itemStyle: {
                color: 'transparent'
              },
              data: [
                // 第一个背景区间：0 到 60，颜色为浅红色
                [
                  {yAxis: 100,itemStyle: {color: 'rgba(49, 48, 255,0.7)'}},
                  {yAxis: 95}
                ],
                // 第二个背景区间：60 到 80，颜色为浅黄色
                [
                  {yAxis: 95,itemStyle: {color: 'rgba(156, 154, 255,0.7)'}},
                  {yAxis: 85}
                ],
                [
                  {yAxis: 85,itemStyle: {color: 'rgba(206, 207, 255,0.7)'}},
                  {yAxis: 70}
                ],
                [
                  {yAxis: 70,itemStyle: {color: 'rgba(255,255,255,0)'}},
                  {yAxis: 0}
                ]
              ]
            },
            markLine: {
              silent: true,
              symbol: 'none',
              lineStyle: {
                width: 2,
                type: 'solid'
              },
              data: [{ yAxis: 50 }],
              z: 0,  // 分割线层级调低（在柱状图下方）
              label: { show: false }
            }
          }
        ]
      });
    },

    async download(){
      const loading = this.$loading({
        lock: true,
        text: '正在整理报告信息，即将开始下载。',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.4)'
      })
      let ageDom = document.getElementById("charts2")
      let ageChart = echarts.getInstanceByDom(ageDom)
      let ageImg = ageChart.getDataURL({
        type: 'png',
        pixelRatio: 2
      })

      let cateDom = document.getElementById("charts3")
      let cateChart = echarts.getInstanceByDom(cateDom)
      let cateImg = cateChart.getDataURL({
        type: 'png',
        pixelRatio: 2
      })

      try {
        const response = await this.$upload('/pdf/pdf?id='+this.$route.query.eid, {
          age: ageImg,
          cate: cateImg
        });
        const blob = response.data;
        const buffer = await blob.arrayBuffer();
        const uint8Array = new Uint8Array(buffer.slice(0, 5)); // 读取前5字节
        const signature = String.fromCharCode(...uint8Array);
        const fileName = '汉语儿童理解与表达词汇测验 '+this.baseInfo.name+' '+this.baseInfo.age
        if (signature === '%PDF-') {
          // 是PDF文件
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = fileName+'.pdf';
          link.click();
          URL.revokeObjectURL(url);
          loading.close()
        } else {
          // 尝试解析JSON错误
          loading.close()
          const text = await blob.text();
          try {
            const error = JSON.parse(text);
            this.$layer.msg(error.message);
          } catch {
            this.$layer.msg('未知错误格式');
          }
        }
      }catch (err) {
        // 显示错误信息（来自接口或默认提示）
        loading.close()
        this.$layer.msg('上传失败:'+ (err.message || '未知错误'));
      }
    },
    startEdit() {
      if (this.isPrint) return;
      this.editingRemark = this.remark;
      this.isEditing = true;
    },
    saveRemark() {
      this.$post("report/saveRemark", {
        exam_id: this.$route.query.eid,
        remark: this.editingRemark
      }).then(res => {
        if (res.code === 200) {
          this.remark = this.editingRemark;
          this.isEditing = false;
          this.$layer.msg("保存成功");
        } else {
          this.$layer.msg(res.msg);
        }
      }).catch(() => {
        this.$layer.msg("网络异常，请稍后重试！");
      });
    },
    cancelEdit() {
      this.isEditing = false;
    }
  },
  created() {
    this.getData();
  }
};
</script>

<style lang="less" scoped>
@import url("../../assets/css/page/revt_result");
.title3{
  font-weight: bold;
}
/*模拟对角线*/
.out{
  border-top:40px transparent solid;/*上边框宽度等于表格第一行行高*/
  width:0px;/*让容器宽度为0*/
  height:0px;/*让容器高度为0*/
  border-left:130px transparent solid;/*左边框宽度等于表格第一行第一格宽度*/
  position:relative;/*让里面的两个子容器绝对定位*/
  font-size: 14px;
}

.table-cate {
  font-style: normal;
  display: block;
  position: absolute;
  top: -40px;
  left: -50px;
  width: 50px;
}

em {
  font-style: normal;
  display: block;
  position: absolute;
  top: -20px;
  right: 80px;
  width: 50px;
}
.score-td{
  text-align: center;
}
.score-td-title{
  width: 95px;
  text-align: center;
}
.num-under{
  //text-decoration: underline;
  //padding: 0 8px;
}
.main-title{
  font-size: 25px;
  font-weight: bold;
  position: relative;
  padding-left: 24px;
  margin-left: 4px;
}
.sn{
  font-size: 25px;
  font-weight: bold;
}
.main-title::before{
  position: absolute;
  content: '';
  top: 50%;
  left: 5px;
  width: 18px;
  height: 18px;
  border: 2px solid #0c2047;
  transform: translate(-7px, -50%);
  border-radius: 50%;
  box-sizing: border-box;
}
.main-title::after{
  position: absolute;
  content: '';
  top: 50%;
  left: 10px;
  width: 10px;
  height: 10px;
  border: 2px solid #0c2047;
  transform: translate(-8px, -50%);
  border-radius: 50%;
  box-sizing: border-box;
}
.subheading{
  font-size: 18px;
  font-weight: bold;
  position: relative;
  padding-left: 20px;
  margin: 16px 0 16px 28px;
  color: #0c2047;
}
.subheading::before{
  position: absolute;
  content: '';
  width: 12px;
  height: 12px;
  background-color: #0c2047;
  left: 0;
  top: 50%;
  transform: rotate(45deg) translate(0, -50%);
}

</style>
